import { render, staticRenderFns } from "./CustomersFrequencyList.vue?vue&type=template&id=1205ed06"
import script from "./CustomersFrequencyList.vue?vue&type=script&lang=js"
export * from "./CustomersFrequencyList.vue?vue&type=script&lang=js"
import style0 from "./CustomersFrequencyList.vue?vue&type=style&index=0&id=1205ed06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports